'use strict';

/**
 * Send a payment-form request and recover once from WordPress' stale-nonce
 * response. The caller owns request construction so the retry is guaranteed to
 * rebuild its body with the freshly applied nonce.
 */
async function requestPaymentFormWithNonceRefresh(options) {
    var response = await options.send();

    if (response.status !== 403) {
        return response;
    }

    var nonce = await options.refreshNonce();
    options.applyNonce(nonce);

    return options.send();
}

module.exports = {
    requestPaymentFormWithNonceRefresh: requestPaymentFormWithNonceRefresh,
};
